// @flow
import React from 'react';
import environment from '../../../../../environment';
import { limitStringEllipsis } from '../../../../../utils/string';
import {
  loadingExecute,
  notFoundLibraryError,
  postPaymentExecute,
  postPaymentExecuteErrorFn,
  postPaymentExecuteSuccess
} from '../../duck';
import { getHttpErrorName, httpErrorsCodeMap } from '../../../../../http';
import analytics from '../../../../../analytics';
import {endpoints, postPaymentExecuteApi} from '../../api';

import type { Node } from 'react';
import type { Order } from '../../../../../entities';
import type { ImplementationType, PaymentImpl } from '../index';
import type {BillingAddressReq, PaymentExecuteReq} from '../../api';
import type { RootState } from '../../../../index';
import type {HTTPError} from "../../../../../error";

import qempo from '../../../../../assets/img/logoq-primary.png'
import {setNewAlert} from "../../../../alert/duck";

type PostCulqiExecuteReq = {
  orderId: string;
  token: string;
  billingAddress: BillingAddressReq;
  service: string;
};

export const onlyAlphaNumericRegex = /[^a-zA-Z0-9 ]/g;

export default class CulqiPayment implements PaymentImpl {
  generateTokenURL = '';
  type: ImplementationType = 'culqi';
  order: Order;
  dispatch: Function;
  // Culqi specific properties
  domainCountry: string;
  billingAddress: ?BillingAddressReq;
  uiId: string = 'culqiUI';
  token: string = undefined;
  installments: string = undefined;
  email: strinng = undefined;
  deviceId: string = undefined;


  responseHandler = () => {
    if (window && window.Culqi && window.Culqi3DS) {
      if (window.Culqi.token && this.billingAddress && this.order) {
        window.Culqi.close();
        const token = window.Culqi.token.id;
        const installments = window.Culqi.token && window.Culqi.token.metadata && window.Culqi.token.metadata.installments ? 
          `${window.Culqi.token.metadata.installments}` : undefined;
        const email = window.Culqi.token && window.Culqi.token.email ? window.Culqi.token.email : undefined;
        this.token = token;
        this.installments = installments;
        this.email = email;

        /* const actionContent: PostCulqiExecuteReq = {
          orderId: this.order.id,
          token,
          billingAddress: this.billingAddress,
          service: this.order.payment && this.order.payment.detail ? this.order.payment.detail.service : '',
        };
        if (installments.length > 0) {
          actionContent.installments = installments;
        }*/
        analytics.fireCustomEvent('Payment Info Entered', {
          category: 'Payment Info',
          action: 'Entered',
          label: this.order.id,
          user_type: 'purchaser',
          user_referrer: window.localStorage.getItem('userReferrer') || '',
          landing_url: window.localStorage.getItem('landingUrl') || '',
          order_id: this.order.id,
          order_formatted_id: this.order.id,
          payment_method: this.order.invoice && this.order.invoice.payment ? this.order.invoice.payment.method : '',
          payment_sub_method: this.order.invoice && this.order.invoice.payment ? this.order.invoice.payment.subtype : '',
          domain_country: this.domainCountry,
          type: 'sync',
          step: 1,
          shipping_method: this.order.serviceTier,
        });

        // console.log('token', token);

        const reqBody: PaymentExecuteReq = {
          type: this.order.invoice.payment.subtype,
          method: this.order.invoice.payment.method,
          billingAddress: this.billingAddress,
          paymentData: {
            token: token,
            deviceId: this.deviceId,
            /*parameters3DS,*/
          },
        };

        console.log('installments:', installments);
        if (installments) reqBody.paymentData.installments = installments;

        console.log('email:', email);
        if (email) reqBody.paymentData.email = email;

        this.dispatch(loadingExecute());

        postPaymentExecuteApi(reqBody, {
          route: endpoints.POST_PAYMENT_EXECUTE.replace(':paymentId', this.order.invoice.payment.id),
        }).toPromise()
            .then((order: Order) => {
              // console.log('SUCCESS !!!!!!!!', order);
              this.dispatch(postPaymentExecuteSuccess(order));
            })
            .catch((e: HTTPError) => {
              if (e.code === 409) {
                console.log('Culqi 3DS is required', token);
                window.Culqi3DS.initAuthentication(token);
              }else {
                // console.log('Gonna call error');
                this.dispatch(postPaymentExecuteErrorFn({
                  code: 400,
                  name: 'UnexpectedError',
                  url: document.location.href,
                }));
                this.dispatch(setNewAlert('checkout', 'error', undefined, 'newOrder.checkout.error.tryWithPaypal'));
              }
            });
      } else {
        // console.log('culqi error');
        // console.log(window.Culqi.error);
        // console.log(window.Culqi.error.user_message);
        this.dispatch(postPaymentExecuteErrorFn({
          code: 400,
          name: getHttpErrorName(httpErrorsCodeMap, 400),
          url: window.location.href,
        }));
      }
    }
  };

  messageResponseHandler = (event) => {
    if (event.origin === window.location.origin &&
        typeof event.data === 'object' &&
        event.data.hasOwnProperty('parameters3DS') &&
        !!event.data.parameters3DS) {
      // console.log('-------------- messageResponseHandler --------------', event);
      const {parameters3DS, loading, error} = event.data;

      if (loading) return;

      if (error) {
        this.dispatch(postPaymentExecuteErrorFn({
          code: 400,
          name: getHttpErrorName(httpErrorsCodeMap, 400),
          url: window.location.href,
          data: {
            name: 'FailedCulqi3DS'
          }
        }));
        return;
      }

      // console.log('parameters3DS =>', parameters3DS);

      const reqBody: PaymentExecuteReq = {
        type: this.order.invoice.payment.subtype,
        method: this.order.invoice.payment.method,
        billingAddress: this.billingAddress,
        paymentData: {
          token: this.token,
          deviceId: this.deviceId,
          parameters3DS,
        },
      };

      console.log('installments 3DS:', this.installments);
      if (this.installments) reqBody.paymentData.installments = this.installments;

      console.log('email 3DS:', this.email);
      if (this.email) reqBody.paymentData.email = this.email;

      console.log('reqBody =>', reqBody);

      this.dispatch(postPaymentExecute(reqBody, this.order));
    }
  };

  setUpPayment(order: Order, dispatch: Function, rootState: RootState) {
    this.order = order;
    this.dispatch = dispatch;
    this.domainCountry = rootState.locale.domainCountry || '';
    const email = rootState.auth.user ? rootState.auth.user.email : '';
    const description = order.items.map(item => item.name).join(', ');
    if (!window.Culqi || !window.Culqi3DS) {
      dispatch(notFoundLibraryError({
        code: 404,
        name: 'notFoundLibraryError',
        url: '',
      }));
      return;
    }
    if (window && window.Culqi && window.Culqi3DS) {
      window.Culqi.publicKey = environment.culqi;
      window.Culqi3DS.publicKey = environment.culqi;

      const amount = parseInt(order.invoice.detail.total.replace('.', ''), 10);
      const desc = (description || '').replace(onlyAlphaNumericRegex, '');

      window.Culqi3DS.settings = {
        charge: {
          totalAmount: amount,
          returnUrl: `https://${environment.env === 'production' ? 'www.qempo.com.pe' : 'staging.qempo.com.pe'}/new-order/checkout/order/${order.id}`,
        },
        card: {
          email: email,
        },
      };

      window.Culqi.settings({
        title: 'Qempo',
        currency: 'USD',
        description: limitStringEllipsis(desc, 77),
        amount: parseInt(order.invoice.detail.total.replace('.', ''), 10),
      });
      // NOTE: Temporary remove installments
      const options: { [key: string]: string | boolean } = {
        installments: true,
        paymentMethods: {
          tarjeta: true,
          yape: true,
          bancaMovil: true,
          agente: true,
          billetera: true,
          cuotealo: true,
        },
        style: {
          logo: `https://${environment.env === 'production' ? 'www.qempo.com.pe' : 'staging.qempo.com.pe'}/${qempo}`,
        },
      };
      if (rootState.locale.locale === 'en') {
        options.lang = 'EN';
      }
      console.log('Culqi options', options);
      window.Culqi.options(options);
      window.Culqi3DS.options = {
        showModal: true,
        showLoading: true,
        showIcon: true,
      };
      window.culqi = this.responseHandler.bind(this);

      // console.log('Generating device id');
      window.Culqi3DS.generateDevice()
        .then(deviceId => {
          // console.log(`Device id = ${deviceId}`);
          this.deviceId = deviceId;
        });

      // console.log('!!!!!!!! SET LISTENER');
      window.removeEventListener( 'message', this.messageResponseHandler, false);
      window.addEventListener( 'message', this.messageResponseHandler, false);
    }
  }

  generateCustomUI = (): Node => undefined;

  executeUIAction(billingAddress: BillingAddressReq, rootState: RootState) {
    analytics.fireCustomEvent('Checkout Step Completed', {
      category: 'Checkout Step',
      action: 'Completed',
      label: this.order.id,
      user_type: 'purchaser',
      user_referrer: window.localStorage.getItem('userReferrer') || '',
      landing_url: window.localStorage.getItem('landingUrl') || '',
      order_id: this.order.id,
      order_formatted_id: this.order.id,
      payment_method: this.order.invoice && this.order.invoice.payment ? '' : this.order.invoice.payment.method,
      payment_sub_method: this.order.invoice && this.order.invoice.payment ? '' : this.order.invoice.payment.subtype,
      domain_country: this.domainCountry,
      type: 'sync',
      step: 1,
      shipping_method: this.order.serviceTier,
    });
    this.billingAddress = billingAddress;
    if (window && window.Culqi) {
      window.Culqi.open();
    }
  };

  showPopUp = (data: string) => undefined;

  clean = () => {
    window.removeEventListener( 'message', this.messageResponseHandler, false);
    const $element = document.getElementById(this.uiId);

    if (document && $element) {
      // $element.remove();
    }
  };
}



// WEBPACK FOOTER //
// ./src/modules/new-order/CheckoutStep/PaymentImpl/Culqi/index.js